<app-auth-layout>
    <div class="cont">
        <img class="logo" src="./assets/images/logo.svg" />
        <form (ngSubmit)="submit()">
          <app-error
            [errcode]="errcode"
          />
          <h1 *ngIf="!twofarequired">Single sign on</h1>
          <h1 *ngIf="twofarequired">2-FA</h1>
    
          <ng-container *ngIf="!twofarequired">
            <p>
              Attempting to log you in to the Control Panel. If this hasn't happened
              yet,
              <a routerLink="/login">log in manually</a>
            </p>
          </ng-container>

          <ng-container *ngIf="twofarequired">
            <sync-text-field
                class="twofa-code"
                label="2FA code"
                [(value)]="twofacode"
            />

            <sync-button
                nativeType="submit"
                class="submit"
                label="Submit"
                [isLoading]="isLoading"
                [disabled]="!isFormValid"
                buttonWidth="236px"
            />
          </ng-container>
        </form>
      </div>
</app-auth-layout>
